<div class="student-email-edit-module">
    <div class="student-email-edit-page-wrap">
        <div class="session-form-hold">
            <div class="pt-8 pb-16">
                <h2 class="mb-1">
                    <strong>Edit Email</strong>
                </h2>
            </div>
            <form [formGroup]="studentEmailEditForm" (ngSubmit)="onSubmit()">
                <div
                    class="mb-1 qtac-error-container"
                    data-test="error-message-register-main"
                    *ngIf="showEmailEditInvalid"
                >
                    {{ studentEmailEditErrorMessage }}
                </div>
                <div class="mb-1">
                    <div>Current Email *</div>
                    <input
                        class="qtac-input"
                        data-test="register-input-current-email"
                        name="currentEmail"
                        formControlName="currentEmail"
                        value=""
                        readonly="true"
                    />
                </div>
                <div class="mb-1">
                    <div>New Email *</div>
                    <input
                            class="qtac-input"
                            data-test="register-input-new-email"
                            name="newEmail"
                            formControlName="newEmail"
                            value=""
                    />
                    <ng-container *ngFor="let error of error_messages.newEmail">
                        <small
                                data-test="error-new-email"
                                *ngIf="formControls.newEmail.hasError(error.type)
                                    && formControls.newEmail.touched"
                                class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>
                <div class="mb-1">
                    <div>Confirm Email *</div>
                    <input
                            class="qtac-input"
                            data-test="register-input-confirm-email"
                            name="confirmEmail"
                            formControlName="confirmEmail"
                            value=""
                    />
                    <ng-container *ngFor="let error of error_messages.confirmEmail">
                        <small
                                data-test="error-confirm-email"
                                *ngIf="formControls.confirmEmail.hasError(error.type)
                                    && formControls.confirmEmail.touched"
                                class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>
                <div cdkAriaLive="mb-1">
                    You will need to login with your new email address and confirm the change by capturing
                        the code emailed to the new email address.
                </div>
                <div class="row">
                    <button
                        data-test="student-cancel-submit"
                        mat-raised-button
                        class="register-confirmation-button mb-1 col"
                        (click)="onNoClick()"
                        type="button"
                    >
                        Cancel
                    </button>
                    <button
                        data-test="student-update-submit"
                        mat-raised-button
                        class="register-confirmation-button mb-1 col"
                        [disabled]="studentEmailEditForm.invalid"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
